<div class="log-out-modal flex-column">
  <div class="modal-header flex-row v-center jc-between">
    <h2 class="m-0" i18n="@@logout.modal.title">Log out</h2>
    <button class="button--unstyled close-btn" (click)="onCancel()" aria-label="Close" i18n-aria-label="@@logout.modal.closeAria">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body flex-column">
    <p class="m-0" i18n="@@logout.modal.message">Are you sure you want to log out, and end session? You are going to lose all your progress</p>
    <p class="m-0" style="margin-top: 1rem; font-weight: 500; color: var(--element-error-color, #d32f2f);" i18n="@@logout.modal.countdown">You will be automatically logged out in {{ secondsRemaining() }} seconds.</p>
  </div>
  <div class="modal-footer flex-row jc-end gap-1">
    <wl-button [config]="cancelBtnConfig" (buttonClick)="onCancel()"></wl-button>
    <wl-button [config]="confirmBtnConfig" (buttonClick)="onConfirm()"></wl-button>
  </div>
</div>